import * as React from 'react'
import { cn } from '@/lib/utils'

export interface EmptyStateProps {
  title: string
  description?: string
  action?: React.ReactNode
  className?: string
  variant?: 'default' | 'quiet'
}

export function EmptyState({
  title,
  description,
  action,
  className,
  variant = 'default',
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 px-6 py-16 text-center',
        variant === 'quiet' && 'm-4 rounded-md border border-dashed border-border',
        className,
      )}
    >
      <p
        className={cn(
          'text-body font-semibold text-foreground',
          variant === 'quiet' && 'text-caption font-normal text-muted-foreground',
        )}
      >
        {title}
      </p>
      {description && <p className="max-w-sm text-body-sm text-muted-foreground">{description}</p>}
      {action && <div className="pt-2">{action}</div>}
    </div>
  )
}
